import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule, Grid } from '@domain-group/suit-theme'

import ListItemImageCover from '@components/ListItemImageCover'

import { UseAgencyMarketingPayload } from '@hooks/useAgencyMarketing'

import { formatEntityCount } from '@functions/entity'

interface FeaturedTagsProps {
  agencyMarketingPayload: UseAgencyMarketingPayload,
}

const FeaturedTags = (props: FeaturedTagsProps) => {
  const { agencyMarketingPayload } = props

  const {
    callbacks: { selectTag },
    featuredTags,
    hasFeaturedTags,
  } = agencyMarketingPayload

  if (!hasFeaturedTags) return null

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      title="Featured"
    >
      <Grid
        // @ts-expect-error TS2322
        gridGap="medium"
        gridAutoRows="1fr"
        gridTemplateColumns="repeat(auto-fill, minmax(400px, 3fr))"
        padding="large"
      >
        {featuredTags.map((tag) => {
          const { formatted_title, template_pages_count } = tag

          // @ts-expect-error TS2322
          const templatePageCount = formatEntityCount({ entityString: 'Template', entityCount: template_pages_count })

          const imageUrl = digObject(tag, 'image.preserved_560x560', '')

          return (
            <ListItemImageCover
              callbacks={{ action: () => selectTag(tag) }}
              imageUrl={imageUrl}
              secondaryTitle={templatePageCount}
              // @ts-expect-error TS2322
              title={formatted_title}
            />
          )
        })}
      </Grid>
    </DashboardModule>
  )
}

export default FeaturedTags
